import { render, staticRenderFns } from "./privacyFile.vue?vue&type=template&id=d7d6c588&scoped=true"
import script from "./privacyFile.vue?vue&type=script&lang=js"
export * from "./privacyFile.vue?vue&type=script&lang=js"
import style0 from "./privacyFile.vue?vue&type=style&index=0&id=d7d6c588&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7d6c588",
  null
  
)

export default component.exports